<template>

    <div v-if="disabledForThisProject">
        <span class="text-gray-400 text-xs pt-3">This app is not available for this project</span>
    </div>
    <div v-else-if="location == 'customer-create' && !portal_enabled">
    </div>
    <div v-else class="font-jira" :class="location == 'customer-edit' ? 'max-w-lg' : ''">

        <div v-if="is_loading" class="text-gray-400 ml-1">
            {{ $t("Loading…") }}
        </div>

        <div v-else-if="!team_data">

            <div v-if="accountType == 'customer'" class="rounded-sm border-2 border-dashed border-gray-100 p-5">
                <p class="text-gray-400 text-center">{{ $t("Screen recording will be available soon.") }}</p>
            </div>
            <div v-else class="rounded border-none p-5 bg-yellow-100">

                <p v-if="location == 'customer-edit'" class="text-sm font-bold text-jira-dark">{{ $t("Screen recording")
                    }}</p>

                <p class="flex "
                    v-bind:class="{ 'flex-row items-center': location != 'customer-edit', 'flex-col items-start': location == 'customer-edit' }">
                    <span class="mr-2">You must complete installation by connecting Atlassian to your Birdie
                        account.</span>
                    <a v-if="!connecting" class="flex flex-row items-center" :href="connect_url" target="_blank"
                        @click="connectLinkClicked">
                        <span>{{ $t("Connect now") }}</span>
                        <vue-feather type="external-link" class="h-3 w-3 ml-2"></vue-feather>
                    </a>
                </p>
            </div>

        </div>

        <div v-else>

            <div v-if="accountType == 'customer' && location == 'customer-sidebar' && portal_enabled">
                <p class="text-sm font-bold text-jira-dark"><span class="font-arial">{{ $t("Screen recording") }}</span>
                </p>
                <p class="pr-1">
                    <a href="#"
                        class="flex items-center font-semibold  rounded hover:no-underline py-2 px-1 ring-0 focus:ring-0 focus:outline-0 outline-transparent ring-transparent"
                        style="outline-width: 0px;" :class="{
                            'text-white bg-blue-700 focus:bg-bg-blue-700 focus:text-text-white hover:text-white hover:bg-blue-700 animate-pulse justify-center': comEnabled,
                            'text-jira-text-grey bg-transparent focus:bg-jira-light-blue focus:text-jira-blue hover:text-jira-text-grey hover:bg-jira-light-grey': !comEnabled
                        }" @click.prevent="openRecorder('receive')">
                        <vue-feather :type="comEnabled ? 'copy' : 'monitor'" class="h-5 w-5 mr-3"></vue-feather>
                        <span v-if="!comEnabled">{{ $t("Send a recording") }}</span>
                        <span v-else>{{ $t("Show recorder window") }}</span>
                    </a>
                </p>
            </div>
            <div v-else-if="accountType == 'atlassian' && location == 'customer-sidebar'">
                <p class="text-sm font-bold text-jira-dark"><span class="font-arial">{{ $t("Screen recording") }}</span>
                </p>
                <p class="pr-1">
                    <a href="#"
                        class="text-jira-text-grey flex items-center font-semibold  rounded hover:no-underline hover:bg-jira-light-grey hover:text-jira-text-grey py-2 px-1 ring-0 focus:ring-0 focus:outline-0 outline-transparent ring-transparent focus:bg-jira-light-blue focus:text-jira-blue"
                        style="outline-width: 0px;" @click.prevent="get_request_link()">
                        <vue-feather type="monitor" class="h-5 w-5 mr-3"></vue-feather>
                        {{ $t("Request a recording") }}
                    </a>
                </p>
                <p class="pr-1">
                    <a href="#"
                        class="flex items-center font-semibold  rounded hover:no-underline py-2 px-1 ring-0 focus:ring-0 focus:outline-0 outline-transparent ring-transparent "
                        style="outline-width: 0px;" :class="{
                            'text-white bg-blue-700 focus:bg-bg-blue-700 focus:text-text-white hover:text-white hover:bg-blue-700 animate-pulse justify-center': comEnabled,
                            'text-jira-text-grey bg-transparent focus:bg-jira-light-blue focus:text-jira-blue hover:text-jira-text-grey hover:bg-jira-light-grey': !comEnabled
                        }" @click.prevent="openRecorder('receive')">
                        <vue-feather :type="comEnabled ? 'copy' : 'send'" class="h-5 w-5 mr-3"></vue-feather>
                        <span v-if="!comEnabled">{{ $t("Send a recording") }}</span>
                        <span v-else>{{ $t("Show recorder window") }}</span>
                    </a>
                </p>
                <p class="pr-1">
                    <a v-if="has_cobrowsing" :href="cobrowse_url"
                        class="text-jira-text-grey flex items-center font-semibold  rounded hover:no-underline hover:bg-jira-light-grey hover:text-jira-text-grey py-2 px-1 ring-0 focus:ring-0 focus:outline-0 outline-transparent ring-transparent focus:bg-jira-light-blue focus:text-jira-blue"
                        style="outline-width: 0px;" target="_blank">
                        <vue-feather type="mouse-pointer" class="h-5 w-5 mr-3"></vue-feather>
                        {{ $t("Start CoBrowsing") }}
                    </a>
                    <span v-else-if="false"
                        class="text-jira-text-grey flex items-center font-semibold rounded py-2 px-1 ring-0 focus:ring-0 focus:outline-0 outline-transparent ring-transparent"
                        style="outline-width:0px;opacity:0.5;" @click.prevent.stop>
                        <vue-feather type="mouse-pointer" class="h-5 w-5 mr-3"></vue-feather>
                        {{ $t("CoBrowsing • disabled") }}
                    </span>

                </p>
            </div>

            <div v-else-if="accountType == 'customer'">
                <p class="text-xs font-bold text-jira-dark">{{ $t("Screen recording") }}</p>
                <p class="pl-1">
                    <a href="#"
                        class="text-white inline-flex items-center font-semibold rounded hover:no-underline hover:opacity-90 hover:text-white py-2 px-3 "
                        :class="{ 'animate-pulse bg-red-500': comEnabled, 'bg-blue-700': !comEnabled }"
                        @click.prevent="openRecorder('receive')">
                        <vue-feather :type="comEnabled ? 'copy' : 'monitor'" class="h-4 w-4 mr-2"></vue-feather>
                        <span v-if="!comEnabled">{{ $t("Send a recording") }}</span>
                        <span v-else>{{ $t("Stop recording") }}</span>
                    </a>
                </p>
                <p class="text-gray-400 text-xs">💡 {{ $t("Tip: Add a screen recording to your request") }}</p>
            </div>

            <div v-else>
                <p v-if="location == 'customer-edit'" class="text-sm font-bold text-jira-dark">{{ $t("Screen recording")
                    }}</p>

                <div class="flex flex-row items-center gap-4 pt-5 pl-1">

                    <a href="#"
                        class="text-jira-dark inline-flex items-center font-semibold bg-gray-100 rounded hover:no-underline hover:opacity-90 hover:bg-gray-200 hover:text-jira-dark py-2 px-3 focus:outline-0"
                        @click.prevent="get_request_link()">
                        <vue-feather type="monitor" class="h-4 w-4 mr-2"></vue-feather>
                        {{ $t("Request a recording") }}
                    </a>

                    <a :href="get_send_link('send')" target="_blank"
                        class=" inline-flex items-center font-semibold rounded hover:no-underline hover:opacity-90  py-2 px-3"
                        :class="{
                            'bg-blue-700 text-white font-bold hover:text-white animate-pulse': comEnabled,
                            'bg-gray-100 text-jira-dark hover:bg-gray-200 hover:text-jira-dark': !comEnabled
                        }">
                        <vue-feather :type="comEnabled ? 'copy' : 'send'" class="h-4 w-4 mr-2"></vue-feather>
                        <span v-if="!comEnabled">{{ $t("Send a recording") }}</span>
                        <span v-else>{{ $t("Show recorder window") }}</span>
                    </a>


                    <a v-if="has_cobrowsing" :href="cobrowse_url"
                        class=" inline-flex items-center font-semibold rounded hover:no-underline hover:opacity-90  py-2 px-3"
                        target="_blank" :class="{
                            'bg-blue-700 text-white font-bold hover:text-white animate-pulse': comEnabled,
                            'bg-gray-100 text-jira-dark hover:bg-gray-200 hover:text-jira-dark': !comEnabled
                        }">
                        <vue-feather type="mouse-pointer" class="h-4 w-4 mr-2"></vue-feather>
                        <span>{{ $t("Start CoBrowsing") }}</span>
                    </a>
                    <span v-else-if="false"
                        class=" inline-flex items-center font-semibold rounded py-2 px-3 bg-gray-100 text-jira-dark hover:bg-gray-200 hover:text-jira-dark"
                        @click.prevent.stop style="outline-width:0px;opacity:0.5;">
                        <vue-feather type="mouse-pointer" class="h-4 w-4 mr-2"></vue-feather>
                        <span>{{ $t("CoBrowsing • disabled") }}</span>
                    </span>




                </div>

            </div>

        </div>

    </div>

</template>





<script>

//import { debounce } from "debounce";
import Spinner from '@/Components/UI/Spinner'

//import '@spartez/vue-atlaskit/dist/bundle.css';
//import Button from '@atlaskit/button';
//import { Button } from '@spartez/vue-atlaskit';



export default {

    name: "IntegrationJira",

    props: ['location', 'recsec', 'base_url', 'project_key', 'project_id'],

    // 4 locations: agent-edit, customer-create, customer-edit, customer-sidebar

    components: {
        Spinner, //Button
    },

    data() {
        return {
            is_loading: true,
            issueKey: null,
            current_user: {},
            team_data: {},
            authStep: 0,
            connecting: false,
            requestProperties: null,
            flag: null,
            sharing_link: "",
            video_comment: "",
            file_uuid: "",
            windowObjectReference: null,
            comEnabled: false,
            openurl: "",
            request_link: "",
            app_location: "",
            accountType: "atlassian", // or customer
            portal_enabled: false,
            disabledForThisProject: false,
            project_key_from_context: null,
        }
    },

    created: function () {
        //console.log("location", this.location)
        //this.requestProperties = new AP.jiraServiceDesk.RequestProperties()
        //console.log('*************************', this.base_url)
    },

    beforeUnmount() {

    },

    mounted: function () {
        this.startAuth()

        var self = this
        //console.log(this.$page.props.app_url)
        /*AP.events.on("jira-servicedesk-request-properties-serialize", function() {
            console.log("jira-servicedesk-request-properties-serialize")
            self.requestProperties.serialize({
                "zest-posted-video": {
                    link: "https://share.hellozest.io/sldfE45",
                    author: "blablabli",
                    way: "received"
                }
            });
        });

        AP.events.on("jira-servicedesk-request-properties-validate", function() {
            console.log("jira-servicedesk-request-properties-validate")
            var valid = true;
            // if (!$("#location").val()) {
            //     $("#location").parent().append("<p class='field-error'>location can't be empty</p>");
            //     valid = false;
            // }
            self.requestProperties.validate(valid);
        });*/

        // AP.getLocation(function(location){
        //     alert(location);
        // });

        AP.events.on('flag.action', function (e) {
            //console.log('event fired', e.actionIdentifier, e.flagIdentifier);
            if (e.actionIdentifier == 'addAsNewComment') {
                self.post_sharing_link()
            }
            else if (e.actionIdentifier == 'addAsNewLink') {
                //console.log("all good")
                self.post_request_link()
            }
            //return true
        });

        window.addEventListener("message", (e) => {

            //console.log("message", e);

            if (!e.origin.includes("birdie")) {
                return;
            }

            if (e.data.state) {
                if (e.data.state == "close") {
                    this.comEnabled = false
                    //this.windowObjectReference = null
                    this.windowObjectReference.close();
                }
            }

            if (e.data.sharing_link && e.data.file_uuid) {
                this.file_uuid = e.data.file_uuid
                this.sharing_link = e.data.sharing_link
                if (e.data.video_comment) {
                    this.video_comment = e.data.video_comment
                }
                this.choice_post()
            }

            if (e.data.closePopup) {
                this.comEnabled = false
                this.windowObjectReference = null
            }

            if (e.data === 'comEnabled') {
                this.comEnabled = true
            }

        });

    },

    methods: {

        startAuth: function () {

            var self = this

            console.log("startAuth getLocation")
            AP.getLocation(function (location) {
                //console.log("app_location", location)
                self.app_location = location
            });
            console.log("startAuth getContext")
            AP.context.getContext(function (response) {
                console.log("context", response);
                if (self.location != "customer-create") {
                    self.issueKey = response.jira.issue.key
                }
                if (response.jira?.project?.key) {
                    self.project_key_from_context = response.jira.project.key
                }

                self.checkCompleteAuth()
            });
            console.log("startAuth request teamData")
            AP.request("/rest/atlassian-connect/1/addons/zest-screen-recording/properties/teamData", {
                success: function (responseText) {
                    console.log("teamData Success", responseText)
                    let responseJson = JSON.parse(responseText)
                    self.team_data = responseJson.value

                    self.check_integration_data()
                    // if (!self.team_data.hasOwnProperty('has_cobrowsing')) {
                    //     self.guess_integration_from_location(self.app_location)
                    // } else {
                    //console.log("App teamData", responseJson.value);
                    self.checkCompleteAuth()
                    // }
                },
                error: function (xhr, statusText, errorThrown) {
                    //console.error("App teamData", xhr.status)
                    if (xhr.status == 401 && self.app_location != "") {
                        self.guess_integration_from_location(self.app_location)
                    } else {
                        self.team_data = null
                        self.checkCompleteAuth()
                    }
                }
            });

            console.log("startAuth getCurrentUser")
            AP.user.getCurrentUser(function (user) {

                if (user.atlassianAccountId) {
                    self.current_user.accountId = user.atlassianAccountId
                }
                if (user.accountType) {
                    self.accountType = user.accountType
                    self.current_user.accountType = user.accountType
                }
                // else {
                //     AP.request(`/rest/api/3/user?accountId=${self.current_user.atlassianAccountId}`, {
                //         success: function (responseText) {
                //             let responseJson = JSON.parse(responseText)
                //             console.log("rest/api/3/user", responseJson)
                //             self.current_user.accountType = responseJson.accountType
                //         },
                //         error: function (xhr, statusText, errorThrown) {
                //             console.error("rest/api/3/myself error", errorThrown)
                //         }
                //     });
                // }
                // if (user.atlassianAccountId) {
                //     self.current_user.accountId = user.atlassianAccountId
                //     self.getUserEmail(user.atlassianAccountId)
                // }
                self.checkCompleteAuth()

                if (self.accountType == "atlassian") {
                    self.$root.$i18n.locale = "en"
                }
            });
            console.log("startAuth request myself")
            AP.request(`/rest/api/3/myself`, {
                success: function (responseText) {

                    let responseJson = JSON.parse(responseText)
                    console.log("rest/api/3/myself", responseJson)
                    self.current_user.accountId = responseJson.accountId
                    self.current_user.accountType = responseJson.accountType
                    self.accountType = responseJson.accountType
                    self.current_user.emailAddress = responseJson.emailAddress
                    self.current_user.displayName = responseJson.displayName
                    self.current_user.timeZone = responseJson.timeZone
                    self.current_user.locale = responseJson.locale
                    self.current_user.raw = responseText

                    if (self.accountType == "atlassian") {
                        self.$root.$i18n.locale = "en"
                    }

                    //console.log("Myself", self.current_user);
                    self.checkCompleteAuth()
                },
                error: function (xhr, statusText, errorThrown) {
                    console.error("rest/api/3/myself error", errorThrown)
                    self.current_user = null
                    self.checkCompleteAuth()
                }
            });
        },

        // getUserEmail: function (atlassianAccountId) {
        //     AP.request(`/rest/api/3/user/email?accountId=${atlassianAccountId}`, {
        //         success: function (responseText) {

        //             let responseJson = JSON.parse(responseText)
        //             console.log("rest/api/3/user/email", responseJson)
        //             email
        //         },
        //         error: function (xhr, statusText, errorThrown) {
        //             console.error("rest/api/3/user/email error", errorThrown)

        //         }
        //     });
        // },

        check_integration_data: function () {
            let params = {
                atlassian_domain: (new URL(this.app_location)).origin
            }
            let url = this.$page.props.app_url + '/jira/check_integration'
            axios.post(url, params)
                .then(response => {

                    if (params.atlassian_domain == "https://zestdev.atlassian.net") {
                        console.log("check_integration_data response", response)
                    }

                    if (response.data) {
                        if (response.data.id && response.data.id === 1) {
                            console.log("response.data", response.data)
                            console.log("this.project_key", this.project_key)
                            console.log("this.project_id", this.project_id)
                        }
                        if (response.data.project_keys_to_remove) {
                            if (response.data.project_keys_to_remove.includes(this.project_key) || response.data.project_keys_to_remove.includes(this.project_id) || response.data.project_keys_to_remove.includes(this.project_key_from_context)) {
                                // this.team_data = null
                                // this.current_user = null
                                this.disabledForThisProject = true
                                // this.checkCompleteAuth()
                                return
                            }
                        }
                        this.team_data.has_cobrowsing = response.data.has_cobrowsing ?? false
                        this.team_data.portal_enabled = response.data.portal_enabled ?? true
                        this.portal_enabled = response.data.portal_enabled !== undefined ? response.data.portal_enabled : true
                        if (params.atlassian_domain == "https://zestdev.atlassian.net") {
                            console.log("portal_enabled", this.portal_enabled, "location", this.location)
                        }
                    }
                })
                .catch(e => {
                    console.error(e)
                });
        },

        guess_integration_from_location: function () {

            this.accountType = "customer"

            let params = {
                atlassian_domain: (new URL(this.app_location)).origin
            }
            let url = this.$page.props.app_url + '/jira/guess_integration'
            axios.post(url, params)
                .then(response => {
                    console.log("guess_integration_from_location response", response)
                    this.team_data = response.data
                    let uniqueId = Date.now().toString(36) + Math.random().toString(36).substring(2);
                    this.current_user = {
                        accountId: uniqueId,
                        displayName: "Anonymous",
                        emailAddress: undefined,
                        locale: undefined,
                        timeZone: undefined,
                        accountType: "customer"
                    }

                    //console.log('this.team_data', this.team_data)
                    this.checkCompleteAuth()
                })
                .catch(e => {
                    console.error(e)
                    this.team_data = null
                    this.current_user = null
                    this.checkCompleteAuth()
                });
        },

        /*searchUserEmail() {
            var self = this
            if (self.current_user.emailAddress) {
                self.checkCompleteAuth()
                return
            }
            //AP.request(`rest/api/2/user?key=${self.current_user.accountId}`, {
            AP.request(`/rest/api/3/user?accountId=${self.current_user.accountId}`, {
                success: function(responseText) {
                    console.log(responseText)
                    let responseJson = JSON.parse(responseText)
                    console.log(responseJson)
                },
                error: function(xhr, statusText, errorThrown){
                    console.log("App teamData", errorThrown)
                    //self.current_user = null
                    self.checkCompleteAuth()
                }
            });
        },*/

        checkCompleteAuth() {
            this.authStep++
            //console.log(this.issueKey, this.team_data, this.current_user)
            if (this.authStep >= 4) {
                this.is_loading = false
                //console.log("team_data", this.team_data)
                //console.log("current_user", this.current_user)
            }
        },

        connectLinkClicked: function () {
            this.connecting = true

        },

        openRecorder: function (way) {
            //console.log("openRecordingWindow clicked")
            //console.log("decodeQueryComponent", AP._util.decodeQueryComponent(window.location.href))


            var winheight = 520;
            /*if (navigator.appVersion.indexOf("Win") != -1) {
                winheight=560;
                if (window.screen.isExtended) { // works on chrome
                    winheight=560;
                    if (window.screen.isExtended) {
                        winheight=620;
                    }
                }
            }*/

            let windowFeatures = "menubar=no,toolbar=no,location=no,directories=no,personalbar=no,status=no,resizable=no,scrollbars=no,dialog=yes,titlebar=no,close=no,height=" + winheight + ",width=675,modal=yes,alwaysRaised=yes,top=20,left=20";

            this.openurl = this.get_send_link(way) //this.base_url + '/recorder?team=' + this.team_data.slugname
            // console.log("openurl is", this.openurl)
            // return
            if (this.windowObjectReference == null || this.windowObjectReference.closed) {
                this.windowObjectReference = window.open(this.openurl, 'birdie', windowFeatures)
                this.enableCom()
            } else {
                this.windowObjectReference.focus()
            }
            //AP.navigator.reload();
        },
        enableCom: function () {
            //console.log("enableCom", this.comEnabled)
            if (this.comEnabled) {
                return
            }
            //console.log("enablecom");
            this.windowObjectReference.postMessage("enablecom", this.openurl);
            setTimeout(function () {
                this.enableCom();
            }.bind(this), 1000);
        },

        get_request_link: function () {

            if (this.request_link != "") {
                this.flag = AP.flag.create({
                    title: this.request_link,
                    body: "👆 " + this.$t("You can copy and send this request link to your customer, or just click below to send it directly."),
                    type: 'success',
                    //close: 'auto',
                    actions: {
                        'addAsNewLink': this.$t("Send the request link")
                    }
                });
                return;
            }

            let domain = this.$page.props.app_url.split('.').slice(-2).join('.')
            const the_link_base = this.$page.props.app_url.replace(this.$page.props.app_url, "https://" + this.team_data.slugname + "." + domain);

            var the_link = the_link_base + "/recorder";
            var jid = {
                // s1:this.current_user.accountId,
                // s2:this.current_user.displayName,
                // s3:this.current_user.emailAddress,
                // s4:this.current_user.locale,
                // s5:this.current_user.timeZone,
                s6: this.team_data.id,
                s7: this.team_data.integration,
                recmode: "tab",
                way: "receive",
                requester: {
                    s1: this.current_user.accountId,
                    s2: this.current_user.displayName,
                    s3: this.current_user.emailAddress,
                    s4: this.current_user.locale,
                    s5: this.current_user.timeZone
                },
                issue: this.issueKey,
                location: this.location,
                app_location: this.app_location
            }

            jid = btoa(unescape(encodeURIComponent(JSON.stringify(jid))))
            //jid = btoa(JSON.stringify(jid));
            let secure_jid = this.secureCode(jid);
            the_link += "?jep=" + encodeURI(secure_jid);
            if (this.$page.props.app_url.indexOf(".test") >= 0) {
                the_link += "&team=" + this.team_data.slugname;
            }

            var params = {
                data: the_link,
                team_slug: this.team_data.slug
            }

            // return the_link
            let url = this.$page.props.app_url + '/tinyurl/save'
            axios.post(url, params)
                .then(response => {

                    this.request_link = the_link_base + "/rec/" + response.data.tinyurl
                    //console.log("response",response)
                    this.flag = AP.flag.create({
                        title: this.request_link,
                        body: "👆 " + this.$t("You can copy and send this request link to your customer, or just click below to send it directly."),
                        type: 'success',
                        //close: 'auto',
                        actions: {
                            'addAsNewLink': this.$t("Send the request link")
                        }
                    });
                })
                .catch(e => {
                    this.flag = AP.flag.create({
                        title: this.$t("An error occurred"),
                        body: this.$t("Maybe try to refresh that page…"),
                        type: 'error',
                        // actions: {
                        //     'copyFailedKey': 'Copy Link'
                        // }
                    });
                    console.error(e)
                });
        },



        get_send_link: function (way) {
            var the_link = this.base_url + "/recorder"
            var jid = {
                s1: this.current_user.accountId,
                s2: this.current_user.displayName,
                s3: this.current_user.emailAddress,
                s4: this.current_user.locale,
                s5: this.current_user.timeZone,
                s6: this.team_data.id,
                s7: this.team_data.integration,
                recmode: "window",
                way: way,
                //requester:"",
                issue: this.issueKey,
                location: this.location,
                app_location: this.app_location
            }
            jid = btoa(unescape(encodeURIComponent(JSON.stringify(jid))))
            //jid = btoa(JSON.stringify(jid));
            let secure_jid = this.secureCode(jid);
            let varname = way == "send" ? "jid" : "jep"
            the_link += "?" + varname + "=" + encodeURI(secure_jid);
            //the_link += "&rid=" + this.ticket.randomId;
            //if (this.$page.props.app_url.indexOf("hellozest.test") >= 0) {
            the_link += "&team=" + this.team_data.slugname;
            //}
            return the_link
        },

        secureCode: function (original) {
            let insert = this.recsec;
            if (original.indexOf(insert) >= 0) {
                return original;
            }
            let randomPlace = Math.floor(Math.random() * (original.length - 1));
            return [original.slice(0, randomPlace), insert, original.slice(randomPlace)].join('');
        },

        choice_post: function () {

            if (this.location == 'customer-create') {
                this.flag = AP.flag.create({
                    title: `${this.sharing_link}`,
                    body: "👆 " + this.$t("This is the link to your recording: copy and paste it right into your message description field."),
                    type: 'success'
                });
            } else {
                this.flag = AP.flag.create({
                    title: `${this.sharing_link}`,
                    body: "👆 " + this.$t("This is the link to your recording: copy and send it manually, or just click below to send it directly."),
                    type: 'success',
                    //close: 'auto',
                    actions: {
                        'addAsNewComment': this.$t("Send recording")
                    }
                });
            }
        },

        post_app: function (issueKey, body, success_callback, fail_callback) {
            AP.request({
                url: `/rest/api/3/issue/${issueKey}/comment`,
                type: "POST",
                contentType: "application/json",
                data: JSON.stringify({ body: body }),
                success: function (responseText) {
                    //console.log(responseText)
                    success_callback(responseText)
                },
                error: function (xhr, statusText, errorThrown) {
                    console.error("AP.request error", xhr, statusText, errorThrown)
                    fail_callback()
                }
            });
            // AP.request({
            //     url: `/rest/api/3/myself`,
            //     success: function(responseText) {
            //         console.log(responseText)
            //     },
            //     error: function(xhr, statusText, errorThrown){
            //         console.error(errorThrown)
            //     }
            // });
        },

        post_request_link_success: function (response) {
            //console.log("*** post_request_link_success called ***")
            AP.flag.create({
                title: this.$t("Your request has been posted"),
                body: this.$t("The recording request was added as a new comment."),
                type: 'success',
                close: 'auto'
            });
            setTimeout(function () {
                if (this.location == "agent-edit") {
                    AP.jira.refreshIssuePage()
                } else {
                    AP.navigator.reload()
                }
            }.bind(this), 500)
        },
        post_request_link_fail: function () {
            //console.log("*** post_request_link_fail called ***")
            AP.flag.create({
                title: this.$t("An error occurred"),
                body: this.$t("You can still send the request, copy this link and send it manually:") + ' ' + this.request_link,
                type: 'error'
            });
        },
        post_request_link: function () {
            var body = {
                version: 1,
                type: "doc",
                content: [
                    {
                        type: "paragraph",
                        content: []
                    }
                ]
            }

            if (this.current_user) {
                if (this.current_user.displayName) {
                    body.content[0].content.push({
                        type: "text",
                        text: this.current_user.displayName,
                        marks: [
                            {
                                type: "strong"
                            }
                        ]
                    })
                    body.content[0].content.push({
                        type: "text",
                        text: ' ' + this.$t("is requesting a recording of your screen.")
                    })
                    body.content[0].content.push({
                        type: "hardBreak"
                    })
                }
            }
            body.content[0].content.push({
                type: "text",
                // text: this.$t("Click here to record your screen"),
                text: this.request_link,
                marks: [
                    {
                        type: "link",
                        attrs: {
                            href: this.request_link,
                            title: this.$t("Screen recording")
                        }
                    }
                ]
            })

            this.post_app(this.issueKey,
                body,
                this.post_request_link_success,
                this.post_request_link_fail)

            return




            // axios.post(url, params)
            // .then(response => {
            //     AP.flag.create({
            //         title: this.$t("Your request has been posted"),
            //         body: this.$t("The recording request was added as a new comment."),
            //         type: 'success',
            //         close: 'auto',
            //         // actions: {
            //         //     'closeReloadKey': 'Reload'
            //         // }
            //     });
            //     setTimeout(function(){
            //         if (this.location == "agent-edit") {
            //             AP.jira.refreshIssuePage()
            //         } else {
            //             AP.navigator.reload()
            //         }
            //     }.bind(this), 500)
            // })
            // .catch(e => {
            //     AP.flag.create({
            //         title: this.$t("An error occurred"),
            //         body: this.$t("You can still send the request: copy this link and send it manually:") + ' ' + this.request_link,
            //         type: 'error',
            //         // actions: {
            //         //     'copyFailedKey': 'Copy Link'
            //         // }
            //     });
            //     console.error(e)
            // });
        },

        post_sharing_link_success: function (response) {
            //console.log("*** post_request_link_success called ***")
            if (response.status == 204) {
                AP.flag.create({
                    title: this.$t("Your recording has already been posted"),
                    body: this.$t("The link to your video was added as a new comment."),
                    type: 'info',
                    close: 'auto'
                });
            } else {
                AP.flag.create({
                    title: this.$t("Your recording has been posted"),
                    body: this.$t("The link to your video was added as a new comment."),
                    type: 'success',
                    close: 'auto'
                });
                setTimeout(function () {
                    if (this.location == "agent-edit") {
                        AP.jira.refreshIssuePage()
                    } else {
                        AP.navigator.reload()
                    }
                }.bind(this), 500)
            }
        },
        post_sharing_link_fail: function () {
            //console.log("*** post_request_link_fail called ***")
            AP.flag.create({
                title: this.$t("An error occurred"),
                body: this.$t("Don’t worry your recording is still there, copy this link and send it manually:") + ' ' + this.sharing_link,
                type: 'error'
            });
        },

        post_sharing_link: function () {
            if (this.accountType == "atlassian") {
                // this api endpoint call does not work from customer accounts (auth error 401)
                //console.log("post_sharing_link from JS API")
                var body = {
                    version: 1,
                    type: "doc",
                    content: [
                        {
                            type: "paragraph",
                            content: []
                        }
                    ]
                }

                var displayName = ""
                if (this.current_user) {
                    if (this.current_user.displayName) {
                        displayName = this.current_user.displayName
                    } else if (this.current_user.emailAddress) {
                        displayName = this.current_user.emailAddress
                    }
                }
                if (displayName != "") {
                    body.content[0].content.push({
                        type: "text",
                        text: displayName,
                        marks: [
                            {
                                type: "strong"
                            }
                        ]
                    })
                    body.content[0].content.push({
                        type: "text",
                        text: ' ' + this.$t("sent a recording:") + " "
                    })
                } else {
                    body.content[0].content.push({
                        type: "text",
                        text: this.$t("New recording sent:") + " "
                    })
                }

                body.content[0].content.push({
                    type: "text",
                    text: this.$t("Click here to watch").toLowerCase(),
                    marks: [
                        {
                            type: "link",
                            attrs: {
                                href: this.sharing_link,
                                title: this.$t("Screen recording")
                            }
                        }
                    ]
                })

                if (this.video_comment != "") {
                    body.content[0].content.push({
                        type: "hardBreak"
                    })
                    body.content[0].content.push({
                        type: "text",
                        text: this.video_comment
                    })
                }

                this.post_app(this.issueKey,
                    body,
                    this.post_sharing_link_success,
                    this.post_sharing_link_fail)

                return

            } else {
                // from customer accounts we must call that api from our backend

                // var sharing_link = this.sharing_link
                //console.log("subdomain is ", this.subdomain)
                let url = this.$page.props.app_url + '/jira/video'
                //let url = `https://zestdev.atlassian.net/rest/servicedeskapi/request/${issueId}/comment/`
                var userName = ""
                if (this.current_user) {
                    if (this.current_user.displayName) {
                        userName = this.current_user.displayName
                    } else if (this.current_user.emailAddress) {
                        userName = this.current_user.emailAddress
                    }
                }

                var params = {
                    issueKey: this.issueKey,
                    video_comment: this.video_comment,
                    video_uuid: this.file_uuid,
                    user_name: userName,
                    sharing_link: this.sharing_link,
                    integration: this.team_data.integration,
                    app_browser_lang: this.$i18n.locale
                };
                //console.log("Axios post", url, params)
                //console.log("post_sharing_link from Backend", url, params)
                axios.post(url, params)
                    .then(response => {
                        //console.log("response",response)
                        if (response.status == 204) {
                            this.flag = AP.flag.create({
                                title: this.$t("Your recording has already been posted"),
                                body: this.$t("The link to your video was added as a new comment."),
                                type: 'info',
                                close: 'auto',
                                // actions: {
                                //     'closeReloadKey': 'Reload'
                                // }
                            });
                        } else {
                            this.flag = AP.flag.create({
                                title: this.$t("Your recording has been posted"),
                                body: this.$t("The link to your video was added as a new comment."),
                                type: 'success',
                                close: 'auto',
                                // actions: {
                                //     'closeReloadKey': 'Reload'
                                // }
                            });
                            setTimeout(function () {
                                if (this.location == "agent-edit") {
                                    AP.jira.refreshIssuePage()
                                } else {
                                    AP.navigator.reload()
                                }
                            }.bind(this), 500)
                        }

                        // if (response.data) {
                        //     //this.is_registered = true
                        // }
                    })
                    .catch(e => {
                        this.flag = AP.flag.create({
                            title: this.$t("An error occurred"),
                            body: this.$t("Don’t worry your recording is still there, copy this link and send it manually:") + ' ' + this.sharing_link,
                            type: 'error',
                            // actions: {
                            //     'copyFailedKey': 'Copy Link'
                            // }
                        });
                        console.error(e)
                    });
            }
        },
    },

    computed: {
        has_cobrowsing: function () {
            if (this.team_data) {
                return this.team_data.has_cobrowsing ?? false
            }
            return false
        },
        cobrowse_url: function () {
            var query = ""
            if (this.current_user.emailAddress) {
                query = this.current_user.emailAddress
            } else if (this.current_user.displayName) {
                query = this.current_user.displayName
            } else if (this.current_user.accountId) {
                query = this.current_user.accountId
            }
            if (query == "") {
                return this.$page.props.app_url + "/cobrowsing"
            }
            return this.$page.props.app_url + '/cobrowsing/jira?q=' + encodeURI(query)
        },
        connect_url: function () {

            let domain = (new URL(this.app_location));
            var toAdd = ""
            if (this.current_user.emailAddress) {
                toAdd = "?email=" + this.current_user.emailAddress
            }
            return `${domain.origin}/plugins/servlet/ac/zest-screen-recording/get-started${toAdd}`

            // var data = {
            //     displayName: this.current_user.displayName,
            //     emailAddress: this.current_user.emailAddress,
            //     timeZone: this.current_user.timeZone,
            //     app_location: domain.origin
            // }
            // data = btoa(JSON.stringify(data))
            // let secure_data = this.secureCode(data)
            // data = encodeURI(secure_data)
            // return this.$page.props.app_url+'/jira/install/'+data

        }
    }

}

</script>

<style scoped scss></style>
